import { createSelector } from '@reduxjs/toolkit';

// Base selector
export const selectIntegrations = (state) => state.integrations;

// Stats selector
export const selectIntegrationsStats = createSelector(
  [selectIntegrations],
  (integrations) => {
    const list = Array.isArray(integrations.integrations)
      ? integrations.integrations
      : [];

    return {
      total: list.length,
      connected: list.filter((i) => i.status === 'connected').length,
      notConnected: list.filter(
        (i) => i.status === 'not_connected' && !i.comingSoon
      ).length,
      totalIdentities: list.reduce((sum, i) => sum + (i.totalIdentities || 0), 0),
    };
  }
);

// Active tasks for a specific integration
export const selectIntegrationTask = (integrationId) =>
  createSelector([selectIntegrations], (integrations) => {
    return integrations.activeTasks[integrationId] || null;
  });

// Connection test for a specific integration
export const selectConnectionTest = (integrationId) =>
  createSelector([selectIntegrations], (integrations) => {
    return integrations.connectionTests[integrationId] || null;
  });

// Get integration by ID
export const selectIntegrationById = (integrationId) =>
  createSelector([selectIntegrations], (integrations) => {
    const list = Array.isArray(integrations.integrations)
      ? integrations.integrations
      : [];
    return list.find((i) => i.id === integrationId);
  });